/**
 * Mock Provider for development
 */

import { BaseProvider } from '../base/BaseProvider'
import type { AIResponseWithReason } from '../../types'

export class MockProvider extends BaseProvider {
  name = 'Mock'
  type: 'direct' | 'proxy' = 'direct'
  
  protected async callAPI(systemPrompt: string, userPrompt: string): Promise<string> {
    // Mock doesn't actually call any API
    await new Promise(resolve => setTimeout(resolve, 500))
    return '{"result": "Mock response"}'
  }
  
  async paraphrase(text: string): Promise<AIResponseWithReason> {
    await new Promise(resolve => setTimeout(resolve, 500))
    const improved = text.replace(/그리고/g, '또한').replace(/하지만/g, '그러나')
    return {
      text: improved,
      reason: '접속사를 더 자연스럽게 변경하고 문장 흐름을 개선했습니다'
    }
  }
  
  async expand(text: string): Promise<AIResponseWithReason> {
    await new Promise(resolve => setTimeout(resolve, 500))
    const expanded = text + ' 추가적으로, 이와 관련된 세부사항을 고려해야 합니다.'
    return {
      text: expanded,
      reason: '관련 세부사항과 추가 설명을 덧붙여 내용을 보강했습니다'
    }
  }
  
  async shrink(text: string): Promise<AIResponseWithReason> {
    await new Promise(resolve => setTimeout(resolve, 500))
    const sentences = text.split('.').filter(s => s.trim())
    const shortened = sentences.slice(0, Math.ceil(sentences.length * 0.6)).join('.') + '.'
    return {
      text: shortened,
      reason: '중복되는 내용과 부수적인 설명을 제거하여 간결하게 정리했습니다'
    }
  }
  
  async summarize(text: string): Promise<string> {
    await new Promise(resolve => setTimeout(resolve, 500))
    const sentences = text.split('.').filter(s => s.trim())
    return '핵심 요약: ' + sentences.slice(0, 2).join('. ') + '.'
  }
  
  async continue(text: string): Promise<string | AIResponseWithReason> {
    await new Promise(resolve => setTimeout(resolve, 500))
    return {
      text: '이어서 작성된 내용입니다.',
      reason: '기본 내용을 자연스럽게 이어서 작성했습니다'
    }
  }
  
  async critique(text: string): Promise<string> {
    await new Promise(resolve => setTimeout(resolve, 500))
    return '전반적으로 잘 작성되었으나, 일부 문장의 명확성을 개선할 수 있습니다.'
  }
}